// removed by extract-text-webpack-plugin
module.exports = {"categoryAds":"styles__categoryAds___1mNIQ","categoryMargin":"styles__categoryMargin___39XSi","centerHeading":"styles__centerHeading___173Li"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/category/styles.css
// module id = rX7o
// module chunks = 3